export default {
  title: {
    id: 'bo_sellers_customer_care_open_tasks_no_open_task_block_title',
    defaultMessage: 'Nice one! Not an open task in sight.',
  },
  surtitle: {
    id: 'bo_sellers_customer_care_open_tasks_no_open_task_block_surtitle',
    defaultMessage: '0 tasks for now.',
  },
  description: {
    id: 'bo_sellers_customer_care_open_tasks_no_open_task_block_description',
    defaultMessage: 'Look back at what you’ve solved in “All requests”',
  },
}
